import React from 'react';
import PosRestaurantDashboard from '../modules/posRestaurant/components/PosRestaurantDashboard';

const PosRestaurantPage = () => {
  return <PosRestaurantDashboard />;
};

export default PosRestaurantPage;
